
import * as React from "react";
import { IActiveOrders } from "../../../interfaces/IOrder";
import OrderItem from "./OrderItem";
import {Api} from "../../../lib/Api";
import SkipButton from "./SkipButton";
import Review from "./Review";
import {Fragment} from "react";

interface IShowOrderProps {
    item                             : any
    reload: Function
    setUrl: any
}


interface IShowOrderState {

}

export default class ShowOrder extends React.Component<IShowOrderProps, IShowOrderState>{

    constructor(props:IShowOrderProps){
        super(props);
        this.state = {

        }
    }


    private acceptedOrder(){
        Api.call('/restaurants/order/acceptOrder', {
            orderId: this.props.item.id
        }, (result) =>{
            this.props.reload();
        });
    }

    private completedOrder(){
        Api.call('/restaurants/order/completedOrder', {
            orderId: this.props.item.id
        }, (result) =>{
            this.props.reload();
        });
    }

    private cancelledOrder(){
        Api.call('/restaurants/order/cancelledOrder', {
            orderId: this.props.item.id
        }, (result) =>{
            this.props.reload();
        });
    }



    render() {
        let item = this.props.item;

        return (

                <div className = "show-order">
                    <div className = "user-content">
                        {item.offer.offerType.img !== undefined &&
                            <div className = "profile-image">
                                <img src = {item.offer.offerType.img}/>
                            </div>
                        }
                        <div className="content">
                            <p className="user-name">{item.creator.firstName} {item.creator.lastName}</p>
                            <div className = "user-address">
                                {item.creator.addressCity}, {item.creator.addressStreet}
                            </div>
                            <div className = "user-phone">
                                {item.creator.phone}
                            </div>
                        </div>
                    </div>
                    <div className = "order-content">
                        <p className = "offerType-name">{item.offer.offerType.name}</p>
                        {
                            item.description &&
                            <>
                                <p className = "order-description-title">Short Customer description:</p>
                                <div className = "order-description">
                                    {item.description}
                                </div>
                            </>
                        }
                        <OrderItem item={item} />

                        {
                            ( item.status.key != 'completed' && item.status.key != 'cancelled' && item.status.key != 'processing' ) &&
                            <button className = "yellow_btn upload-btn">
                                <img src = "/img/upload_photo_icon.png" />
                                <p>Photo request</p>
                            </button>
                        }

                        {
                            item.status.key === 'processing' &&
                            <div className = "process-order grey-bg">
                                <p className = "creator-name">Starting work:</p>
                                 <div className = "remaining-time">
                                    {
                                        Object.keys(item.formattedStartDateTime).map((timeType, index) => (
                                            <>
                                                <div className = "time">
                                                    <p>{item.formattedStartDateTime[timeType]}</p>
                                                    <label>{timeType}</label>
                                                </div>
                                                {
                                                    index != Object.keys(item.formattedStartDateTime).length - 1 &&
                                                    <div className = "colon">:</div>
                                                }

                                            </>
                                        ))
                                    }
                                </div>
                            </div>
                        }


                        {
                            ( item.status.key != 'completed' && item.status.key != 'cancelled' ) &&
                            <div className = "buttons-box">
                                {
                                    item.status.key == 'pending' &&
                                    <button className = "green_btn" onClick={() => this.acceptedOrder()}>I accepted this job</button>
                                }
                                {
                                    item.status.key == 'processing' &&
                                    <button className = "green_btn" onClick={() => this.completedOrder()}>The job was done</button>

                                }
                                <SkipButton order={item} reload={this.props.reload} />
                            </div>
                        }

                        {
                            item.status.key === 'completed' &&
                            <div className = "buttons-box">
                                <button className = "green_btn" onClick={() => this.props.setUrl('/restaurant/order/review', {order: item})}>Add review</button>
                            </div>
                        }

                        <div className = "back-btn">
                            <button type="button" className="back_btn" onClick={() => this.props.reload()}>Back to orders</button>
                        </div>

                    </div>
                </div>

        );
    }
}
